let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ja1FH")).then(() => parcelRequire('cDh22'));